<template>
    <div>
        <v-overlay :value="loadingOnboardingList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-tabs grow :value="selectedListStatusIndex" @change="changeTab" height="32">
            <v-tab v-for="item in listStatuses" :key="item">
                {{ t(item) }}
            </v-tab>
        </v-tabs>
        <v-card class="col-item" flat style="border-top: 1px solid lightgray">
            <v-data-table
                :headers="tableHeaders"
                class="onboardings-table"
                dense
                :items="onboardings"
                :items-per-page="100"
                :footer-props="footerProps"
            >
                <template v-slot:item="{ item }">
                    <tr
                        :key="'onboarding_' + item.id"
                        @click="handleTableRowClick(item)"
                        :class="{ activeTableRow: activeOnboarding && parseInt(item.id) === parseInt(activeOnboarding.id) }"
                    >
                        <td>{{ item.id }}</td>
                        <td>{{ item.created_at }}</td>
                        <td>{{ item.updated_at }}</td>
                        <td>{{ item.name }}</td>
                        <td style="text-align: left">{{ item.identification_code }}</td>
                        <td style="text-align: right"><span :style="{ 'background-color': getStatusColor(item.status) }" class="dot"></span></td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="900">
            <onboarding-admin-view v-if="$route.name === 'onboarding-admin-view'" />
            <onboarding-admin-edit v-if="$route.name === 'onboarding-admin-edit'" />
        </v-navigation-drawer>
    </div>
</template>
<script>
import {mapActions, mapMutations, mapState} from "vuex";
import OnboardingAdminView from "./onboarding-view";
import OnboardingAdminEdit from "./onboarding-edit";
import router from "@/router";
export default {
    name: "onboarding-admin-list",
    components: { OnboardingAdminView, OnboardingAdminEdit },
    data() {
        return {
            tableHeaders: [
                {
                    text: "ID",
                    align: "left",
                    value: "id"
                },
                {
                    text: this.t("Created at"),
                    align: "left",
                    value: "created_at"
                },
                {
                    text: this.t("Updated at"),
                    align: "left",
                    value: "updated_at"
                },
                {
                    text: this.t("Name"),
                    align: "left",
                    value: "name"
                },
                {
                    text: this.t("Identification code"),
                    align: "left",
                    value: "identification_code"
                },
                {
                    text: this.t("Status"),
                    align: "end",
                    value: "country"
                }
            ],
            footerProps: { "items-per-page-options": [25, 50, 100, 500] },
            mainDrawerOpen: null,
        };
    },
    computed: {
        ...mapState([
            "user",
            "drawerOpen",
            "requestError",
            "errorMessage",
            "requestSuccess",
        ]),
        ...mapState('onboarding', [
            'onboardings',
            'activeOnboarding',
            'loadingOnboardingList',
            'selectedListStatusIndex',
            'listStatuses'
        ]),
    },
    async mounted() {
        if (this.user.role === "admin") {
            await this.getOnboardings();
            await this.getCompanies();
            document.addEventListener("keydown", this.handleKeyboardListener);
            const drawerState = localStorage.getItem("mainDrawerOpen");
            if (drawerState) {
                this.mainDrawerOpen = JSON.parse(drawerState);
            } else {
                this.mainDrawerOpen = true;
            }
        } else {
            router.push("/admin/landing");
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        ...mapActions('onboarding', ['getOnboardings', 'getOnboardingData']),
        ...mapActions(['getCompanies']),
        ...mapMutations('onboarding', ['setSelectedListStatusIndex']),
        async handleTableRowClick(onboarding) {
            if (this.$route.name !== "onboarding-admin-view") {
                this.$router.push({ name: "onboarding-admin-view", params: { onboardingId: onboarding.id } });
                return;
            }
            if (
                this.$route.name === "onboarding-admin-view" &&
                parseInt(onboarding.id) !== parseInt(this.$route.params.onboardingId)
            ) {
                this.$router.push({ name: "onboarding-admin-view", params: { onboardingId: onboarding.id } });
                await this.getOnboardingData(onboarding.id)
            }
        },
        async handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.drawerOpen) {
                this.$router.push({ name: "onboarding-admin-list" });
            }
            if (
                this.activeOnboarding &&
                Object.keys(this.activeOnboarding).length > 0 &&
                this.activeOnboarding.id !== "new" &&
                this.$route.name !== "onboarding-admin-edit"
            ) {
                let currentOnboardingIndex = this.onboardings.findIndex(p => p.id === this.activeCompany.id);
                if (e.key === "ArrowUp") {
                    if (currentOnboardingIndex !== 0) {
                        const newOnboardingId = this.onboardings[currentOnboardingIndex - 1].id;
                        await this.getOnboardingData(newOnboardingId)
                        this.$router.push({ name: this.$route.name, params: { onboardingId: newOnboardingId } });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentOnboardingIndex + 1 !== this.onboardings.length) {
                        const newOnboardingId = this.onboardings[currentOnboardingIndex + 1].id;
                        await this.getOnboardingData(newOnboardingId)
                        this.$router.push({ name: this.$route.name, params: { onboardingId: newOnboardingId } });
                    }
                }
            }
        },
        changeTab(index) {
            this.setSelectedListStatusIndex(index)
        },
        getStatusColor(status) {
            if (status === "confirmed") {
                return "#4CAF50";
            } else if (["failed", "cancelled"].includes(status)) {
                return "#FF0000";
            } else if (status === "completed") {
                return "#0066ff";
            } else if (status === "pending") {
                return "#eec01f";
            } else {
                return "#999999";
            }
        },
    }
};
</script>
<style scoped>
.activeTableRow {
    background-color: #707070;
    color: #fff;
}
.activeTableRow:hover {
    background-color: #8d8d8d !important;
    color: #fff !important;
}
</style>
